import { WORKALIZER_APP_ORIGIN } from '@workalizer/shared/config';
export var homeUrl = '/';
export var signInUrl = '/sign-in';
export var authGoogleCallbackUrl = '/auth/google/callback';
export var dashboardUrl = '/dashboard';
export var installationUrl = '/installation';
export var appsUrl = '/apps';
export var profileUrl = '/profile';
export var settingsUrl = '/settings';
export var publicSiteUrl = 'https://workalizer.com/';
export var appProductionUrl = "".concat(WORKALIZER_APP_ORIGIN, "/");
export var demoUrl = 'https://demo.workalizer.com/';
export var performanceInsightsUrl = '/performance-insights';
export var docAlertsUrl = '/doc-alerts';
export var onboardingUrl = '/onboarding';
export var postInstallUrl = '/post-install';
export var itemDetailsUrl = '/item-details';
export var helpCenterUrl = 'https://workalizer.com/help/';
export var contactUrl = 'https://workalizer.com/contact/';
export var privacyPolicyUrl = 'https://workalizer.com/privacy-policy/';
export var termsOfServiceUrl = 'https://workalizer.com/terms-of-service/';
export var statusUrl = 'https://status.workalizer.com/';
export var blogUrl = 'https://workalizer.com/blog';
export var guidesUrl = 'https://workalizer.com/help/guides-and-how-tos/';
export var faqUrl = 'https://workalizer.com/help/faq/';
export var X_AccountUrl = 'https://x.com/workalizer_app';
export var orgUnitsAndUsersHelpUrl = 'https://workalizer.com/help/settings/settings-org-units-users/';
export var googleAdminManageOrgUnitsUrl = 'https://knowledge.workspace.google.com/admin/users/advanced/add-an-organizational-unit';
export var googleAdminMoveUsersToOrgUnitUrl = 'https://knowledge.workspace.google.com/admin/users/advanced/move-users-to-an-organizational-unit';
